__turbopack_context__.v({
  "followersInfo": "cxaSlq_followersInfo",
  "infoIcon": "cxaSlq_infoIcon",
  "subAvatar": "cxaSlq_subAvatar",
  "subAvatarPlaceholder": "cxaSlq_subAvatarPlaceholder",
  "subAvatars": "cxaSlq_subAvatars",
  "subCount": "cxaSlq_subCount",
  "subStack": "cxaSlq_subStack",
});
